import { render, staticRenderFns } from "./ClienteRecomendados.vue?vue&type=template&id=7ec6267f"
import script from "./ClienteRecomendados.vue?vue&type=script&lang=js"
export * from "./ClienteRecomendados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports